// extracted by mini-css-extract-plugin
module.exports = {"container":"UserDetails_container__31g-6","divider":"UserDetails_divider__wJG7h","infoContainer":"UserDetails_infoContainer__h7obQ","submitBtn":"UserDetails_submitBtn__3t4yC"};